<template>
  <div class="travel-cell">
    <van-cell class="special-cell">
      <div class="travel-type">
        <slot name="type" />
      </div>
      <div class="travel-content">
        <div class="travel-content-top">
          <p class="custom-title">
            <slot name="add" />
          </p>
          <span>
            <slot name="money" />
          </span>
        </div>
        <p class="travel-date">
          <slot name="date" />
        </p>
      </div>
    </van-cell>
  </div>
</template>

<script>
export default {
  name: 'travel-cell'
};
</script>

<style scoped lang="scss">
.travel-cell {
  .van-cell__value {
    flex: 1;
    display: flex;
    .travel-type {
      margin: 0 12px 0 16px;
      width: 48px;
      height: 48px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      .svg-icon{
        font-size: 48px;
      }
    }
    .travel-content {
      flex: 1;
      position: relative;
      &::after{
        position: absolute;
        content: " ";
        pointer-events: none;
        right: -16px;
        bottom: -9px;
        left: 0;
        border-bottom: 1px solid $border-color;
        z-index: 10;
      }
      .travel-content-top {
        display: flex;
        font-size: 16px;
        span {
          color: $value-des-color;
        }
      }
      .custom-title {
        flex: 1;
      }
      span {
        flex: none;
      }
      .travel-date {
        font-size: 14px;
        color: $title-color;
      }
    }
  }
}
</style>
